import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateRecurringPaymentMutationVariables = Types.Exact<{
  transactionId: Types.Scalars["ID"];
  input?: Types.InputMaybe<Types.RecurringPaymentRuleInput>;
}>;

export type CreateRecurringPaymentMutation = {
  __typename?: "Mutation";
  createRecurringPayment: { __typename?: "AutocategorizationRule"; id: number };
};

export const CreateRecurringPaymentDocument = gql`
  mutation createRecurringPayment(
    $transactionId: ID!
    $input: RecurringPaymentRuleInput
  ) {
    createRecurringPayment(transactionId: $transactionId, input: $input) {
      id
    }
  }
`;
export type CreateRecurringPaymentMutationFn = Apollo.MutationFunction<
  CreateRecurringPaymentMutation,
  CreateRecurringPaymentMutationVariables
>;

/**
 * __useCreateRecurringPaymentMutation__
 *
 * To run a mutation, you first call `useCreateRecurringPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecurringPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecurringPaymentMutation, { data, loading, error }] = useCreateRecurringPaymentMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRecurringPaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRecurringPaymentMutation,
    CreateRecurringPaymentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateRecurringPaymentMutation,
    CreateRecurringPaymentMutationVariables
  >(CreateRecurringPaymentDocument, options);
}
export type CreateRecurringPaymentMutationHookResult = ReturnType<
  typeof useCreateRecurringPaymentMutation
>;
export type CreateRecurringPaymentMutationResult =
  Apollo.MutationResult<CreateRecurringPaymentMutation>;
export type CreateRecurringPaymentMutationOptions = Apollo.BaseMutationOptions<
  CreateRecurringPaymentMutation,
  CreateRecurringPaymentMutationVariables
>;
